import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from "react-router-dom";
//import { DynamicComponents } from './DynamicComponents';
import { Header } from '../../layout/partials/Header.Component';
// import  HeaderCollapse  from '../../layout/partials/HeaderCollapse.Component';
// import HeaderCollapseButton from '../../layout/partials/HeaderCollapseButton.Component';


export const Home = () => {
    const { isMenuCollapse, selectedMenu } = useSelector((state) => state.menus);
    return ( 
		<div className='main--container'>
            <header className="header mb-2">
                {/* {!isMenuCollapse ? <Header /> : <HeaderCollapse />} */}
                 <Header />
                {/* {selectedMenu?.childrens?.length > 0  && <HeaderCollapseButton /> } */}
            </header>
            <Outlet />
        </div>
    )
}